import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { UpdateGroupModal } from "../components/Groups/UpdateGroupModal";
import { CreateGroupModal } from "../components/Groups/CreateGroupModal";
import { Box, Button, Typography } from "@mui/material";
import { ContentBlock } from "../shared/sharedStyles";
import { GroupsTable } from "../components/Groups/GroupsTable";
import axiosInstance from '../axios.config';
import AddIcon from '@mui/icons-material/Add';


const Groups = () => {
    const lngsltd = JSON.parse(localStorage.getItem('languageSelected'));

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    //Validation Variable
    const [groupNameError, setGroupNameError] = useState('');
    const [editGroupNameError, setEditGroupNameError] = useState('');

    const [showadd, setShowAdd] = useState(false);
    const handleCloseAdd = () => {
        setShowAdd(false);
        clear();
        clearErrors();
    };
    const handleShowAdd = () => setShowAdd(true);

    //For Adding new Group
    const [group, setGroup] = useState('')

    //For Updating existing Group
    const [editID, setEditId] = useState('')
    const [editGroup, setEditGroup] = useState('')

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);


    useEffect(() => {
        getData();
    }, [])

    const getData = () => {
        axiosInstance.get(`/Group`)
            .then((result) => {
                const responseData = result.data;
                setData(responseData);
            })
            .catch((error) => {
                //  console.log(error)
            })
    }

    const handleEdit = (id) => {
        handleShow();
        axiosInstance.get(`/Group/${id}`)
            .then((result) => {
                setEditGroup(result.data.groupName);
                setEditId(id);
            })
            .catch((error) => {
                // console.log(error)
            })
    }

    const handleDelete = (id) => {
        if (window.confirm(lngsltd["Are you sure to delete this Group?"]) === true) {
            axiosInstance.delete(`/Group/${id}`)
                .then((result) => {
                    toast.success(lngsltd['Group has been deleted']);
                    getData();
                })
                .catch((error) => {
                    toast.error(error);
                })
        }
    }

    const handleUpdate = () => {
        let formIsValid = true;

        if (!editGroup) {
            setEditGroupNameError(lngsltd['Name is required']);
            formIsValid = false;
        } else {
            setEditGroupNameError('');
        }

        if (formIsValid) {
            const url = `/Group/${editID}`;
            const data = {
                "groupID": editID,
                "groupName": editGroup
            }
            axiosInstance.put(url, data)
                .then((result) => {
                    handleClose();
                    getData();
                    clear();
                    toast.success(lngsltd['Group has been updated']);
                }).catch((error) => {
                    toast.error(error);
                })
        }
    }

    const handleSave = () => {
        let formIsValid = true;

        if (!group) {
            setGroupNameError(lngsltd['GroupName is required']);
            formIsValid = false;
        } else {
            setGroupNameError('');
        }

        if (formIsValid) {
            const url = `/Group`;
            const data = {
                "groupname": group,

            }
            axiosInstance.post(url, data)
                .then((result) => {
                    handleCloseAdd();
                    getData();
                    clear();
                    toast.success(result.data);
                }).catch((error) => {
                    toast.error(error);
                })
        }
    }

    const clearErrors = () => {
        setGroupNameError('');
    }

    const clear = () => {
        setGroup('');
        setEditGroup('');
        setEditId('');
        setGroupNameError('');
    }

    return (
        <Box className='fullHW' px={6} py={4}  display="flex" flexDirection="column">
            <Typography variant="h5" fontWeight={600}>List of Groups</Typography>
            <ContentBlock sx={{ flexGrow: 1, display: "flex", flexDirection: "column", py: 4, "& p": { m: 0 } }}>
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <Button size="large" variant="contained" startIcon={<AddIcon />} onClick={handleShowAdd} sx={{ textTransform: "initial" }}>
                        {lngsltd["Add Group"]}
                    </Button>
                </Box>
                <Box mt={2} flexGrow={1} overflow="hidden" width="90%">
                    <GroupsTable
                        data={data}
                        lngsltd={lngsltd}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                    />
                </Box>
            </ContentBlock>
            <UpdateGroupModal
                show={show}
                handleClose={handleClose}
                lngsltd={lngsltd}
                editGroup={editGroup}
                setEditGroup={setEditGroup}
                editGroupNameError={editGroupNameError}
                handleUpdate={handleUpdate}
            />
            <CreateGroupModal
                showadd={showadd}
                handleCloseAdd={handleCloseAdd}
                lngsltd={lngsltd}
                group={group}
                setGroup={setGroup}
                groupNameError={groupNameError}
                handleSave={handleSave}
            />
            <ToastContainer
                autoClose={2000}
                progressClassName='custom-toast-progress-bar'
            />
        </Box>

    )
}

export default Groups


